import { z } from 'zod';

import { getAmendmentQtyGuardErrors } from '#/modules/momMgmt/workOrder/helper/amendmentQty';
import { workOrderExpenseRowSchema } from '#/modules/momMgmt/workOrder/schemas/workOrderSchema';

const qtySchema = z.union([z.string(), z.number()]).refine(
  (value) => value !== '' && value != null && !Number.isNaN(Number(value)) && Number(value) >= 0,
  { message: '數量須為 ≥ 0 的數字' },
);

const substitutionSchema = z.object({
  sourceGroupMtrId: z.string().min(1),
  fromMtrId: z.string().min(1),
  toMtrId: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  changeEnabled: z.boolean().optional(),
  sourceGroupMtrNo: z.string().optional().nullable(),
  sourceGroupMtrName: z.string().optional().nullable(),
  fromMtrNo: z.string().optional().nullable(),
  fromMtrName: z.string().optional().nullable(),
}).superRefine((row, ctx) => {
  if (!row.changeEnabled) {
    return;
  }
  if (!row.toMtrId || row.toMtrId === row.fromMtrId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '異動已開啟，請選擇與目前料不同的替代料',
      path: ['toMtrId'],
    });
  }
});

export const workOrderAmendmentFormSchema = z.object({
  scrapQty: qtySchema,
  cancelQty: qtySchema,
  manufacturingQty: z.union([z.string(), z.number()]).optional().nullable(),
  completedQty: z.union([z.string(), z.number()]).optional().nullable(),
  issueReason: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  mtrSubstitutions: z.array(substitutionSchema).default([]),
  expenses: z.array(workOrderExpenseRowSchema).default([]),
  expensesLocked: z.boolean().optional(),
}).superRefine((values, ctx) => {
  getAmendmentQtyGuardErrors(values).forEach((error) => {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: error.message,
      path: [error.path],
    });
  });
});

export const WORK_ORDER_AMENDMENT_FIELD_LABELS = {
  scrapQty: '報廢量',
  cancelQty: '取消量',
  issueReason: '事由',
  remark: '備註',
  mtrSubstitutions: '替代料',
  'mtrSubstitutions.toMtrId': '替代料（改為）',
  expenses: '費用',
  'expenses.name': '費用名稱',
  'expenses.amount': '費用金額',
};

export function resolveWorkOrderAmendmentFieldLabel(path) {
  if (WORK_ORDER_AMENDMENT_FIELD_LABELS[path]) {
    return WORK_ORDER_AMENDMENT_FIELD_LABELS[path];
  }
  if (path?.startsWith('mtrSubstitutions.') && path.endsWith('.toMtrId')) {
    return WORK_ORDER_AMENDMENT_FIELD_LABELS['mtrSubstitutions.toMtrId'];
  }
  if (path?.startsWith('expenses.')) {
    return path.endsWith('.amount')
      ? WORK_ORDER_AMENDMENT_FIELD_LABELS['expenses.amount']
      : WORK_ORDER_AMENDMENT_FIELD_LABELS['expenses.name'];
  }
  return path;
}
